import * as types from './miscellaneousActionType';

// Miscellaneous Site Data - start
export const fetchMiscSiteDataRequest = (data) => ({
    type: types.FETCH_MISC_SITE_DATA_REQUEST,
    payload: data
});
export const fetchMiscSiteDataSuccess = (data) => ({
    type: types.FETCH_MISC_SITE_DATA_SUCCESS,
    payload: data
});
export const fetchMiscSiteDataFailure = (error) => ({
    type: types.FETCH_MISC_SITE_DATA_FAILURE,
    payload: error
});
export const fetchSitesDropdownRequest = () => ({
    type: types.FETCH_SITES_DROPDOWN_REQUEST
});
export const fetchSitesDropdownSuccess = (data) => ({
    type: types.FETCH_SITES_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchSitesDropdownFailure = (error) => ({
    type: types.FETCH_SITES_DROPDOWN_FAILURE,
    payload: error
});
export const fetchPracticeSiteMappingRequest = (siteID) => ({
    type: types.FETCH_PRACTICE_SITE_MAPPING_REQUEST,
    payload: siteID
});
export const fetchPracticeSiteMappingSuccess = (data) => ({
    type: types.FETCH_PRACTICE_SITE_MAPPING_SUCCESS,
    payload: data
});
export const fetchPracticeSiteMappingFailure = (error) => ({
    type: types.FETCH_PRACTICE_SITE_MAPPING_FAILURE,
    payload: error
});
export const saveUpdateMiscSitesRequest = (payload) => ({
    type: types.SAVE_UPDATE_MISC_SITES_REQUEST,
    payload: payload
});
export const saveUpdateMiscSitesSuccess = (data) => ({
    type: types.SAVE_UPDATE_MISC_SITES_SUCCESS,
    payload: data
});
export const saveUpdateMiscSitesFailure = (error) => ({
    type: types.SAVE_UPDATE_MISC_SITES_FAILURE,
    payload: error
});

export const clearMiscSiteData = () => ({
    type: types.CLEAR_MISC_SITE_DATA
});
// Miscellaneous Site Data - end
